import { useNavigate } from "react-router-dom";

const UserAccountExploreNavigation = (userId) => {
  const navigate = useNavigate(); 
  
  const goToUserAccountExplore = () => {
    navigate(`/useraccount-explore/${userId}`); // Ensure this route exists in your app
  };

  return { goToUserAccountExplore }; // ✅ Return an object
};

export default UserAccountExploreNavigation;